import script from "./TeacherStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherStatus.vue?vue&type=script&setup=true&lang=js"

import "./TeacherStatus.vue?vue&type=style&index=0&id=1c93e168&scoped=true&lang=css"
import "./TeacherStatus.vue?vue&type=style&index=1&id=1c93e168&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c93e168"]])

export default __exports__